<template>
  <!-- 头部 -->
  <div class="navigation">
    <div class="nav">
      <div class="caidan" @click="clickMenu">
        <i
          style="font-size: 30px; line-height: 70px; margin-left: 10px"
          class="el-icon-s-unfold"
        ></i>
      </div>
      <div class="hLeft">
        <img src="../assets/logs.png" class="top" alt="" @click="hores()" />
        <!-- <div @click="hores()" class="top">幕 课 网</div>
        <span  @click="hores()" class="fo">WWW.MUKE.COM</span> -->
      </div>
      <el-drawer
        title="菜单"
        :visible.sync="drawer"
        direction="ltr"
        @close="handleCloseDrawer"
        :modal-append-to-body="false"
        style="width: 500px"
      >
        <el-menu
          :default-active="activeRoute"
          active-text-color="#4CCAFF"
          mode="vertical"
          router
          @select="handleSelect"
          style="z-index: 999"
        >
          <el-menu-item
            v-for="(item, index) in juyrt"
            :key="index"
            class="bar"
            :index="item.path"
            >{{ item.name }}</el-menu-item
          >
        </el-menu>
      </el-drawer>
      <div>
        <!-- :default-active="activeRoute.toString()||activeMenu.toString()" -->
        <el-menu
          :default-active="activeRoute"
          active-text-color="#4CCAFF"
          class="el-menu-demo"
          mode="horizontal"
          router
          @select="handleSelect"
        >
          <el-menu-item
            v-for="(item, index) in juyrt"
            :key="index"
            class="bar"
            :index="item.path"
            >{{ item.name }}</el-menu-item
          >
        </el-menu>
      </div>
      <div class="searchbox" style="visibility: hidden">
        <el-input placeholder="请输入内容" size="mini" v-model="name">
          <!-- <template slot="append"><el-button  class=" appdsa"@click="selratelistis()" round>搜索</el-button></template> -->
        </el-input>
        <el-button
          class="appdsa"
          @click="selratelistis(name)"
          v-preventReClick="3000"
          round
          >搜索</el-button
        >
      </div>
      <div class="Logregister" v-if="this.$store.state.isLogin === false">
        <span @click="dialogVisible = true">登录</span>/

        <span @click="registered = true">注册</span>
      </div>
      <div class="Logregister" v-else>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            欢迎,
            {{
              this.$store.state.user.name
                ? this.$store.state.user.name
                : this.$store.state.user.phone
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="个人信息"> 个人信息</el-dropdown-item>
            <el-dropdown-item command="修改密码">修改密码</el-dropdown-item>
            <el-dropdown-item command="退出登录">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="personal"></div>
      <!-- 登录 -->
      <el-dialog
        class="popout-box"
        style="padding: 30px 40px 0 40px"
        :visible.sync="dialogVisible"
        width="320px"
        :before-close="handleClose"
        :lock-scroll="true"
        :close-on-click-modal="false"
        :append-to-body="true"
        :center="true"
      >
        <div class="logo">
          <div class="logo-pi">
            <img src="../assets/phone.png" alt="" />
            <h4>登录</h4>
          </div>
          <el-input
            class="logindialogs"
            v-model="phone"
            placeholder="请输入手机号"
          ></el-input>
          <el-input
            class="logindialogs"
            v-model="password"
            placeholder="请输入密码"
            show-password
          ></el-input>
          <p>
            没有账号？<span @click="(registered = true), (dialogVisible = true)"
              >注册</span
            >
          </p>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button
            v-if="password !== '' && phone != false && checked == true"
            type="primary"
            class="The-login1"
            @click="login()"
            v-preventReClick="2000"
            >登录</el-button
          >
          <el-button
            v-else
            class="The-login"
            @click="Checkthe()"
            v-preventReClick="2000"
            >登录</el-button
          >
          <div class="Underthelogin">
            <el-checkbox class="chekbox" v-model="checked"></el-checkbox>
            <p>
              我已阅读并同意<span>《用户服务协议》</span> 和
              <span>《隐私政策》</span>
            </p>
          </div>
        </span>
      </el-dialog>
      <!-- 注册 -->
      <el-dialog
        class="popout-box"
        style="padding: 30px 40px 0 40px"
        :visible.sync="registered"
        width="320px"
        :before-close="handleClose"
        :lock-scroll="true"
        :close-on-click-modal="false"
        :append-to-body="true"
        :center="true"
      >
        <template slot="title">
          <div
            class="titleZise"
            @click="(dialogVisible = true), (registered = false)"
          >
            <img class="imgsreturn" src="../assets/returns.png" alt="" />
            <div>返回登录</div>
          </div> </template
        ><el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="logo1">
            <div class="logo-pi">
              <img src="../assets/phone.png" alt="" />
              <h4>注册</h4>
            </div>
            <el-input
              class="logindialog"
              v-model="ruleForm.phonez"
              placeholder="请输入手机号"
            ></el-input>
            <el-form-item label-width="0" class="froms" prop="passwordz">
              <el-input
                class="logindialog"
                v-model="ruleForm.passwordz"
                placeholder="请输入密码"
                type="password"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="0" class="froms" prop="passwordzc">
              <el-input
                class="logindialog"
                v-model="ruleForm.passwordzc"
                placeholder="请输入密码"
                type="password"
              ></el-input>
            </el-form-item>
            <el-input
              class="logindialog"
              v-model="ruleForm.Verification"
              placeholder="请输入验证码"
            >
              <template slot="append" style="background-color: #fff">
                <el-button
                  v-if="
                    ruleForm.phonez.length <= 11 &&
                    canClick === false &&
                    ruleForm.passwordzc !== ruleForm.passwordz
                  "
                  class="buttons"
                >
                  发送验证码
                </el-button>
                <el-button
                  type="primary"
                  v-if="
                    ruleForm.phonez.length >= 11 &&
                    canClick === false &&
                    ruleForm.passwordzc === ruleForm.passwordz
                  "
                  class="buttonss"
                  style="
                    padding: 3px 6px;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #16b0ec;
                    line-height: 18px;
                    background: #fff;
                    border: 1px solid #ececec;
                    border-radius: 3px;
                  "
                  @click="Verificationcodes()"
                >
                  发送验证码
                </el-button>
                <el-button
                  v-if="canClick"
                  class="buttons"
                  style="background: #fff; color: #b8b8b8; width: 80px"
                  @click="Verificationcodes()"
                >
                  {{ totalTime }}s
                </el-button>
              </template></el-input
            >
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            v-if="
              checked == true &&
              ruleForm.phonez !== '' &&
              ruleForm.passwordz !== '' &&
              ruleForm.passwordzc !== '' &&
              ruleForm.Verification !== ''
            "
            class="The-login1"
            @click="submitForm('ruleForm')"
            v-preventReClick="2000"
            >注册</el-button
          >

          <el-button
            v-else
            @click="Checkthes()"
            class="The-login"
            v-preventReClick="2000"
            >注册</el-button
          >

          <div class="Underthelogin">
            <el-checkbox class="chekbox" v-model="checked"></el-checkbox>
            <p>
              我已阅读并同意<span>《用户服务协议》</span> 和
              <span>《隐私政策》</span>
            </p>
          </div>
        </span>
      </el-dialog>
      <!-- 修改密码 -->
      <el-dialog
        :modal-append-to-body="false"
        :visible.sync="dialogVisiblemm"
        width="20%"
        :before-close="handleClose"
        center="center"
        :close-on-click-modal="false"
      >
        <template solt="title"
          ><p style="padding: 20px" align="center" v-if="!istuwe">验证码</p>
          <p align="center" style="padding: 20px" v-if="istuwe">修改密码</p>
        </template>
        <el-form
          :model="passwords"
          status-icon
          :rulesa="rulesa"
          ref="passwords"
          class="demo-ruleForms"
        >
          <div class="indial" v-if="!istuwe">
            <el-input
              style="margin-bottom: 10px"
              placeholder="请输入手机号"
              v-model="phonenumberis"
              :disabled="true"
            >
            </el-input>
            <el-input
              class="logindialog"
              v-model="validationss"
              placeholder="请输入验证码"
            >
              <template slot="append" style="background-color: #fff">
                <el-button
                  v-if="canClick === false"
                  type="primary"
                  class="buttonss"
                  style="
                    padding: 3px 6px;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #16b0ec;
                    line-height: 18px;
                    background: #fff;
                    border: 1px solid #ececec;
                    border-radius: 3px;
                  "
                  @click="finnbacks()"
                >
                  发送验证码
                </el-button>
                <el-button
                  v-if="canClick"
                  class="buttons"
                  style="background: #fff; color: #b8b8b8; width: 80px"
                >
                  {{ totalTime }}s
                </el-button>
              </template></el-input
            >
          </div>
          <div class="sssmm" v-if="istuwe">
            <el-form-item label-width="0" prop="Changemm1">
              <el-input
                type="password"
                placeholder="请输入新密码"
                v-model="passwords.Changemm1"
              >
              </el-input>
            </el-form-item>
            <el-form-item label-width="0" prop="Changemm2">
              <el-input
                type="password"
                v-model="passwords.Changemm2"
                placeholder="请输入新密码"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button class="Passwords" @click="dialogVisiblemm = false">取 消</el-button> -->
          <el-button
            class="Passwords"
            type="primary"
            v-if="istuwe"
            @click="thepasswordyes('passwords')"
            >确 定</el-button
          >
          <el-button
            class="Passwords"
            type="primary"
            v-if="!istuwe"
            @click="passwordss()"
            >下一步</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Loginnterface,
  Verificationcode,
  registered,
  finnback,
  finnbnoteverifyack,
  thepassword,
} from "../api/patient";
import Bus from "@/utils/bus";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.passwordzc !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.passwordz) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      activeRoute: "",
      name: "",

      juyrt: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "在线课程",
          path: "/myinformation",
        },
        {
          name: "健康科普",
          path: "/HealthSciencePopularization",
        },
        {
          name: "优质论文",
          path: "/QualityPapers",
        },
        {
          name: "成果转化",
          path: "/achievement",
        },
        // {
        //   name: '热度排行',
        //   path: '/heatnumber'
        // },
        {
          name: "素材下载",
          path: "/materialpage",
        },
        {
          name: "关于我们",
          path: "/aboutus",
        },
      ],

      phonenumberis: "",
      istuwe: false,
      passwords: {
        Changemm: "",
        Changemm1: "",
        Changemm2: "",
      },
      validationss: "",
      dialogVisiblemm: false,
      dialogVisible: false,
      registered: false,
      checked: "",
      activeIndex: "",
      phone: "",
      password: "",

      ruleForm: {
        phonez: "",
        passwordz: "",
        passwordzc: "",
        Verification: "",
      },
      rules: {
        passwordz: [{ validator: validatePass, trigger: "blur" }],
        passwordzc: [{ validator: validatePass2, trigger: "blur" }],
      },
      rulesa: {
        Changemm1: [{ validator: validatePass, trigger: "blur" }],
        Changemm2: [{ validator: validatePass2, trigger: "blur" }],
      },
      totalTime: 60,
      canClick: false, // 添加canClic,
      key: "",
      items: [],
      drawer: false,
    };
  },
  async created() {
    if ((await Object.keys(this.$store.state.user).length) === 0) {
      // alert(Object.keys(this.$store.state.user).length)
      // alert(1)
    } else {
      // alert(2)
      // alert(Object.keys(this.$store.state.user).length)
    }
  },
  mounted() {
    Bus.$on("activeRouter", (e) => {
      this.activeRoute = e;
    });
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    handleCloseDrawer() {
      this.drawer = false;
    },
    //点击菜单
    clickMenu() {
      this.drawer = true;
    },
    // 提示勾选
    Checkthe() {
      if (this.phone === "" || this.password === "") {
        this.$message({
          showClose: true,
          message: "请输入账号密码",
          type: "warning",
        });
      } else {
        this.$message({
          showClose: true,
          message: "请先勾选用户协议",
          type: "warning",
        });
      }
    },
    Checkthes() {
      if (
        this.ruleForm.Verification === "" ||
        this.ruleForm.passwordzc === "" ||
        this.ruleForm.passwordz === "" ||
        this.ruleForm.phonez === ""
      ) {
        this.$message({
          showClose: true,
          message: "请输入完整",
          type: "warning",
        });
      } else {
        this.$message({
          showClose: true,
          message: "请先勾选用户协议",
          type: "warning",
        });
      }
    },
    hores() {
      this.$router.push("/home");
    },
    // activeMenu () {
    //   const route = this.$route
    //   // console.log(route);
    //   this.key = route.name
    //   // console.log(this.key);
    //   this.activeRoute = this.key
    //   const { meta, path } = route
    //   if (meta.activeMenu) {
    //     return meta.activeMenu
    //   }
    //   return path
    // },
    // 索索框
    selratelistis(item) {
      if (item) {
        this.$router.push(`/Searchpage/${item}`);
        this.name = "";
      } else {
        this.$message({
          showClose: true,
          message: "请输入搜索内容",
          type: "warning",
        });
      }
    },
    // 修改密码
    thepasswordyes(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var arry = new FormData();
          arry.append("phone", this.phonenumberis);
          arry.append("password", this.passwords.Changemm2);
          thepassword(arry).then((rsm) => {
            if (rsm.code === "OK") {
              this.$message({
                showClose: true,
                message: rsm.msg,
                type: "success",
              });
              this.dialogVisible = true;
              this.passwords.Changemm1 = "";
              this.passwords.Changemm2 = "";
              localStorage.removeItem("Token");
              this.$store.dispatch("checkToken");
              this.$router.push("/");
              this.dialogVisiblemm = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 验证码
    async passwordss() {
      var data = new FormData();
      data.append("phone", this.phonenumberis);
      data.append("mobile_code", this.validationss);
      var res = await finnbnoteverifyack(data);

      if (res.code === "OK") {
        this.istuwe = true;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 验证码
    finnbacks() {
      var data = new FormData();
      data.append("phone", this.$store.state.usert.phone);
      finnback(data).then((res) => {
        if (res.code === "OK") {
          this.canClick = true;
          this.countDown();
        }
      });
    },
    // 判断获取下拉框
    handleCommand(command) {
      if (command === "退出登录") {
        this.Logout();
      } else if (command === "个人信息") {
        this.$router.push("/personalnav");
      } else if (command === "修改密码") {
        this.dialogVisiblemm = true;
        this.phonenumberis = this.$store.state.user.phone;
      }
    },
    // 退出登录
    Logout() {
      localStorage.removeItem("xek_Token");
      localStorage.removeItem("Token");
      this.$store.dispatch("checkToken");
      this.$router.push({ name: "Home" }).catch((err) => err);
    },
    // 登录
    async login() {
      const thisa = new FormData();
      thisa.append("phone", this.phone);
      thisa.append("password", this.password);
      await Loginnterface(thisa).then((res) => {
        if (res.code === "OK") {
          this.dialogVisible = false;
          this.$message({
            showClose: true,
            message: "登录成功",
            type: "success",
          });
          localStorage.setItem("Token", res.wuser.token);
          this.$store.commit("userts", res.wuser);
          this.$store.dispatch("getUser", res.wuser);
          this.$store.commit("checkToken", true);
          location.reload();
        } else if (res.code === "ERR") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 注册
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = new FormData();
          data.append("phone", this.ruleForm.phonez);
          data.append("password", this.ruleForm.passwordz);
          data.append("mobile_code", this.ruleForm.Verification);
          data.append("organization", "北京大学");
          registered(data).then((res) => {
            if (res.code === "OK") {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.registered = false;
              this.dialogVisible = true;
            }
            if (res.code === "ERR") {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 验证码
    Verificationcodes() {
      const data = new FormData();
      data.append("phone", this.ruleForm.phonez);
      Verificationcode(data).then((res) => {
        if (res.code === "OK") {
          this.canClick = true;
          this.countDown();
        }
        if (res.code === "ERR") {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    // 验证码倒计时倒计时
    countDown() {
      // this.content = this.totalTime + 's后重新发送' // 这里解决60秒不见了的问题
      const clock = window.setInterval(() => {
        this.totalTime--;
        if (this.totalTime < 0) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.canClick = false;
          this.totalTime = 60;
        }
      }, 1000);
    },
    handleSelect(key, keyPath) {
      this.handleCloseDrawer();
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.dialogVisiblemm = false;
      this.registered = false;
    },
  },
};
</script>

<style scoped lang="scss">
.navigation {
  z-index: 999;
  white-space: nowrap;
  width: 100%;
  height: 70px;
  background: #ffffff;
  display: flex;
  border-bottom: 2px solid rgba(0, 0, 0, 0.04);
  .nav {
    // z-index: 300;
    width: 1290px;
    height: 100%;
    background-color: #fff;
    margin: 0 auto;
    display: flex;
    .caidan {
      display: none;
    }
    .hLeft {
      margin-left: 60px;
      display: flex;
      flex-direction: column;
      .top {
        cursor: pointer;
        width: 112px;
        height: 50px;
        font-size: 20px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: #4ccaff;
        letter-spacing: 3px;
        text-align: center;
        margin: 0 5px;
        margin-top: 11px;
        margin-bottom: 8px;
      }
      .fo {
        // width: 169px;
        height: 15px;
        font-size: 14px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: #4ccaff;
      }
    }
    .el-menu-demo {
      margin-top: 5px;
      margin-left: 50px;
      border-bottom: solid 0px #e6e6e6;
      display: flex;
      .bar {
        font-size: 15px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        // color: #4CCAFF;
      }
    }
    .Logregister {
      display: flex;
      // margin-left: 60px;
      cursor: pointer;
      margin: 27px 0 0 27px;
      height: 15px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4ccaff;
    }
  }
}
.logo {
  padding-top: 60px;
  padding-left: 40px;
  padding-right: 40px;
  display: flex;
  flex-direction: column;
  .logo-pi {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
    img {
      width: 11px;
      height: 16px;
    }
    h4 {
      margin-left: 10px;
      height: 15px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      line-height: 18px;
    }
  }
  p {
    height: 12px;
    margin-top: 15px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #b8b8b8;
    line-height: 18px;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 36px;
  }
  span {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
    line-height: 18px;
    cursor: pointer;
  }
}
.logindialogs {
  width: 240px;
  margin-top: 12px;
  ::v-deep .el-input__inner {
    border: none;
    border-bottom: 1px solid#ECECEC;
    border-radius: 0;
  }
}
.logindialog {
  width: 240px;
  margin-top: 12px;
  ::v-deep .el-input__inner {
    border: none;
    border-bottom: 1px solid#ECECEC;
    border-radius: 0;
  }
  ::v-deep .el-input-group__append,
  .el-input-group__prepend {
    background: none;
    border: 0px;
    border-bottom: 1px solid #ececec;
  }
}

.The-login {
  width: 240px;
  height: 34px;
  background: #8adcff;
  border-radius: 3px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 0px;
  border: 0px;
}
.el-dialog__wrapper ::v-deep .el-dialog {
  padding: 0;
  height: 400px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.el-checkbox__input::v-deep.chekbox {
  border: 1px solid #4ccaff;
}
.Underthelogin {
  display: flex;
  margin-top: 10px;
  .chekbox {
    margin-left: 15px;
  }
  p {
    margin-left: -21px;
    // padding-top: 2px;
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #b8b8b8;
    -webkit-transform: scale(0.8);
    span {
      color: #4ccaff;
    }
  }
}

.titleZise {
  padding-left: 20px;
  padding-top: 20px;
  height: 14px;
  text-align: left;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #dbdbdb;

  cursor: pointer;
  display: flex;
  .imgsreturn {
    padding-top: 3px;
    width: 7px;
    height: 13px;
    margin-right: 10px;
    line-height: 14px;
  }
  .div {
    height: 14px;
    line-height: 14px;
  }
}

.logo1 {
  display: flex;
  padding-top: 18px;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 20px;
  flex-direction: column;
  margin: auto;
  .logo-pi {
    display: flex;
    justify-content: center;
    padding-bottom: 5px;
    img {
      width: 11px;
      height: 16px;
    }
    h4 {
      margin-left: 10px;
      height: 15px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      line-height: 18px;
    }
  }
  .logindialog {
    margin-top: 7px;
  }
}

.The-login1 {
  width: 240px;
  height: 34px;
  // background: #ffffff;
  border-radius: 3px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 0px;
}
.buttons {
  padding: 3px 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #b8b8b8;
  line-height: 18px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 3px;
  outline: none;
}
.logindialog::v-deep.buttonss {
  padding: 3px 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #16b0ec;
  line-height: 18px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 3px;
  // outline: none;
}
.froms {
  margin-bottom: 10px;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  // background-color: #f9fafc;
}
.sssmm {
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 50px;
  padding-bottom: 100px;
}
.demo-ruleForms {
  // height: 265px;
  .indial {
    display: flex;
    flex-direction: column;
    padding-left: 60px;
    padding-right: 60px;
    padding-top: 50px;
    padding-bottom: 100px;
  }
}
.Passwords {
  padding-top: 10px;
  padding-bottom: 10px;
}
.searchbox {
  width: 255px;
  line-height: 70px;
  margin-left: 20px;
  ::v-deep .el-input__inner {
    height: 30px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  ::v-deep .el-input-group__append {
    margin-left: 100px;
    // line-height: 30px;
    border: 0px;
    background: #fff;
  }
}
.appdsa {
  position: relative;
  left: -69px;
  top: 0.1rem;
  padding: 0px;
  width: 70px;
  height: 29.5px;
  background: #4ccaff;
  border-left: 0px solid;
  border-radius: 15px;
  color: #fff;
}
button {
  background: #4ccaff;
  border: 0;
}
button:hover {
  background: #4ccaffc9;
}

// 适配手机端
@media (max-width: 768px) {
  .navigation {
    width: 100vw;
    height: 70px;
    .nav {
      width: 100vw;
      height: 70px;
      .caidan {
        display: block;
        margin-right: 30px;
      }
      .hLeft {
        margin-left: 70px;
        .top {
          cursor: pointer;
          width: 112px;
          height: 50px;
        }
      }
      .el-menu-demo {
        display: none;
      }
      .Logregister {
        display: flex;
        margin-left: 30px;
      }
    }
  }
  .logo {
    padding-top: 60px;
    padding-left: 40px;
    padding-right: 40px;
    display: flex;
    flex-direction: column;
    .logo-pi {
      display: flex;
      justify-content: center;
      margin-bottom: 25px;
      img {
        width: 11px;
        height: 16px;
      }
      h4 {
        margin-left: 10px;
        height: 15px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        line-height: 18px;
      }
    }
    p {
      height: 12px;
      margin-top: 15px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #b8b8b8;
      line-height: 18px;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 36px;
    }
    span {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4ccaff;
      line-height: 18px;
      cursor: pointer;
    }
  }
  .logindialogs {
    width: 240px;
    margin-top: 12px;
    ::v-deep .el-input__inner {
      border: none;
      border-bottom: 1px solid#ECECEC;
      border-radius: 0;
    }
  }
  .logindialog {
    width: 240px;
    margin-top: 12px;
    ::v-deep .el-input__inner {
      border: none;
      border-bottom: 1px solid#ECECEC;
      border-radius: 0;
    }
    ::v-deep .el-input-group__append,
    .el-input-group__prepend {
      background: none;
      border: 0px;
      border-bottom: 1px solid #ececec;
    }
  }

  .The-login {
    width: 240px;
    height: 34px;
    background: #8adcff;
    border-radius: 3px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 0px;
    border: 0px;
  }
  .el-dialog__wrapper ::v-deep .el-dialog {
    padding: 0;
    height: 400px;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .el-checkbox__input::v-deep.chekbox {
    border: 1px solid #4ccaff;
  }
  .Underthelogin {
    display: flex;
    margin-top: 10px;
    .chekbox {
      margin-left: 15px;
    }
    p {
      margin-left: -21px;
      // padding-top: 2px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #b8b8b8;
      -webkit-transform: scale(0.8);
      span {
        color: #4ccaff;
      }
    }
  }

  .titleZise {
    padding-left: 20px;
    padding-top: 20px;
    height: 14px;
    text-align: left;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #dbdbdb;

    cursor: pointer;
    display: flex;
    .imgsreturn {
      padding-top: 3px;
      width: 7px;
      height: 13px;
      margin-right: 10px;
      line-height: 14px;
    }
    .div {
      height: 14px;
      line-height: 14px;
    }
  }

  .logo1 {
    display: flex;
    padding-top: 18px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
    flex-direction: column;
    margin: auto;
    .logo-pi {
      display: flex;
      justify-content: center;
      padding-bottom: 5px;
      img {
        width: 11px;
        height: 16px;
      }
      h4 {
        margin-left: 10px;
        height: 15px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        line-height: 18px;
      }
    }
    .logindialog {
      margin-top: 7px;
    }
  }

  .The-login1 {
    width: 240px;
    height: 34px;
    // background: #ffffff;
    border-radius: 3px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 0px;
  }
  .buttons {
    padding: 3px 6px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #b8b8b8;
    line-height: 18px;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 3px;
    outline: none;
  }
  .logindialog::v-deep.buttonss {
    padding: 3px 6px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #16b0ec;
    line-height: 18px;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 3px;
    // outline: none;
  }
  .froms {
    margin-bottom: 10px;
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    // background-color: #f9fafc;
  }
  .sssmm {
    padding-left: 60px;
    padding-right: 60px;
    padding-top: 50px;
    padding-bottom: 100px;
  }
  .demo-ruleForms {
    // height: 265px;
    .indial {
      display: flex;
      flex-direction: column;
      padding-left: 60px;
      padding-right: 60px;
      padding-top: 50px;
      padding-bottom: 100px;
    }
  }
  .Passwords {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .searchbox {
    display: none;
  }
  .appdsa {
    position: relative;
    left: -69px;
    top: 0.1rem;
    padding: 0px;
    width: 70px;
    height: 29.5px;
    background: #4ccaff;
    border-left: 0px solid;
    border-radius: 15px;
    color: #fff;
  }
  button {
    background: #4ccaff;
    border: 0;
  }
  button:hover {
    background: #4ccaffc9;
  }
  ::v-deep .el-dialog {
    width: 90% !important;
  }
  ::v-deep .el-drawer__header {
    color: black;
    font-size: 18px;
  }
}
</style>
